import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  isFirstSignIn: false,
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setAuthentication: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setIsFirstSignIn: (state, action) => {
      state.isFirstSignIn = action.payload;
    },
  },
});

export const { setAuthentication, setIsFirstSignIn } =
  authenticationSlice.actions;

export const authenticationReducer = authenticationSlice.reducer;
